export default __webpack_public_path__ + "2e2e04e62609459cc59dd191c743f609.png";